// components
import UserListItemMobile from './userListItem_mobile';

// react
import { useEffect, useState } from 'react';
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Route, Switch } from "react-router-dom";
import { BeatLoader } from 'react-spinners';

// kendo
import kendo from "@progress/kendo-ui";
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { Input } from '@progress/kendo-react-inputs';

// css
import styles from './userList_mobile.module.css';
// import "./userInfo_mobile.css";

// services
import { getDongs, getRgns } from './../../../service/areaService';
import { getUser, isAdmin, isDeveloper, setDelToken } from "../../../service/authService";
import { getUserStatPage } from '../../../service/monitor/allStatusService';
import { getUserList } from '../../../service/mobile/userInfoService';
import { isRgnAdmin } from './../../../service/authService';
import { isManager } from './../../../service/authService';

function UserListMobile({conn, setUpdateLoginStatus, loginStatus, rgnList, dongList}) {
  const userInfo = getUser();
  const history = useHistory();
  const location = useLocation();

  const defualtValRgn = { rgnTermSimple: "시/군/구", rgnCode: "" };
  const defualtValDong = { dongTermSimple: "읍/면/동", dongCode: "" };

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    // skip: 0,
    // take: 1000,
    isNotPlan: 'Y',
    meainStatCode: null,
    rgnCode: userInfo.rgnCode,
    rgnTermSimple: null,
    // 드롭다운 시군구 표출 값
    rgns : { rgnTermSimple: "시/군/구", rgnCode: "" },
    dongCode: userInfo.dongCode,
    dongTermSimple: null,
    // 드롭다운 읍면동 표출 값
    dongs : { dongTermSimple: "읍/면/동", dongCode: "" },
    userTerm : "" , 
  });
  const [userTermValue, setUserTermValue] = useState("");

  const [dataSource, setDataSource] = useState({
    userDataList: [],
    rgnList: [], 
    dongList: [],
    count: 0,
  });

  const [eventColor, setEventColor] = useState({
    all: "#5c5f60",
    normal: "#898989",
    warn: "#898989",
    danger: "#898989",
    off: "#898989",
  });

  // 대상자 검색 (이벤트 선택)
  const searchEventSelect = (e) => {
    search.meainStatCode = e.currentTarget.id;
    setLoading(true);
    getUserList(conn, search)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.userDataList = response;
        item.count = response.length;
        return item;
      })
    setLoading(false);
    })
    .catch(error => console.log('getUserList Error', error));

    // 버튼 색상 변경
    if(e.currentTarget.id === "") {
      setEventColor(eventColor => {
        const item = { ...eventColor};
        item.all = "#5c5f60"
        item.normal = "#898989"
        item.warn = "#898989"
        item.danger = "#898989"
        item.off = "#898989"
        return item;
      })
    } else if(e.currentTarget.id === "20001") {
      setEventColor(eventColor => {
        const item = { ...eventColor};
        item.all = "#898989"
        item.normal = "#5c5f60"
        item.warn = "#898989"
        item.danger = "#898989"
        item.off = "#898989"
        return item;
      })
    } else if(e.currentTarget.id === "20002") {
      setEventColor(eventColor => {
        const item = { ...eventColor};
        item.all = "#898989"
        item.normal = "#898989"
        item.warn = "#5c5f60"
        item.danger = "#898989"
        item.off = "#898989"
        return item;
      })
    } else if(e.currentTarget.id === "20004") {
      setEventColor(eventColor => {
        const item = { ...eventColor};
        item.all = "#898989"
        item.normal = "#898989"
        item.warn = "#898989"
        item.danger = "#5c5f60"
        item.off = "#898989"
        return item;
      })
    } else if(e.currentTarget.id === "20003") {
      setEventColor(eventColor => {
        const item = { ...eventColor};
        item.all = "#898989"
        item.normal = "#898989"
        item.warn = "#898989"
        item.danger = "#898989"
        item.off = "#5c5f60"
        return item;
      })
    }
  }
  
  // 대상자 검색 (지역 선택)
  const searchAreaSelect = (e) => {
    if (e.target.name === "rgn") {
      // 드롭다운 검색조건 변경
      search.rgnCode = e.target.value.rgnCode;
      search.rgns = e.target.value;
      // 하위 데이터 초기화
      search.dongCode = "";
      search.dongs = { dongTermSimple: "읍/면/동", dongCode: "" };
      search.userTerm = "";
      setUserTermValue("");
      // 대상자 데이터 조회
      getUserDataList();
      // 읍면동 데이터 조회
      getDongs(conn, e.value.rgnCode).then(result => {
        setDataSource(dataSource => {
          const item = { ...dataSource };
          item.dongList = result;
          return item;
        })
      });
    } else if (e.target.name === "dong") {
      // 드롭다운 검색조건 변경
      search.dongCode = e.target.value.dongCode;
      search.dongs = e.target.value;
      // 하위 데이터 초기화
      search.userTerm = "";
      setUserTermValue("");
      // 대상자 데이터 조회
      getUserDataList();
    }
  }
  // 대상자 검색 (대상자 입력)
  const searchUserSelect = (e) => {
    // 대상자 이름 값 설정
    setUserTermValue(e.target.value);
    // 대상자 이름 검색 조건 추가
    search.userTerm = e.target.value;
    getUserList(conn, search)
    .then(response => {
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.userDataList = response;
        item.count = response.length;
        return item;
      })
    })
    .catch(error => console.log('getUserList Error', error));
  }

  // 시군구, 읍면동 리스트 가져오기
  const getRgnDongList = () => {
    setLoading(true);
    // 시군구
    getRgns(conn)
    .then(response => {
      setSearch(search => {
        const item = { ...search };
        item.rgns = response.find(item => item.rgnCode === userInfo.rgnCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.rgnList = response
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getRgns error = ", error);
    });
    // 읍면동
    getDongs(conn, userInfo.rgnCode)
    .then(response => {
      setSearch(search => {
        const item = { ...search };
        item.dongs = response.find(item => item.dongCode === userInfo.dongCode);
        return item;
      })
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.dongList = response;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      console.log("getDongs error = ", error);
    });
  }

  // 유저 정보 가져오기
  const getUserDataList = () => {
    setLoading(true);
    getUserList(conn, search)
    .then(response => {
      // dataSource.userDataList = response;
      setDataSource(dataSource => {
        const item = { ...dataSource };
        item.userDataList = response;
        item.count = response.length;
        return item;
      })
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      console.log('getUserList Error', error);
    });
  }
  
  // 페이지 로드
  useEffect( () => {
    getUserDataList();
    getRgnDongList();
  }, [])

  // const onScroll = () => {
  //   console.log("window.innerHeight = ", window.innerHeight);
  //   console.log("document.documentElement.scrollTiop = ", document.documentElement.scrollTop);
  //   console.log("document.documentElement.offsetHeight = ", document.documentElement.offsetHeight);
  //   if (
  //     window.innerHeight + document.documentElement.scrollTop
  //     === document.documentElement.offsetHeight
  //   ) {
  //     setLoading(true);
  //     getUserStatPage(conn, search)
  //     .then(response => {
  //       console.log("response2 = ", response);
  //       setDataSource(response)
  //       // response.results.map(item => dataSource.results.push(item));
  //       setSearch(search.skip+1);
  //       setLoading(false);
  //     })
  //     .catch(error => console.log('getUserStatPage Error', error));
  //   }
  // }

  // useEffect(() => {
  //   window.addEventListener('scroll', onScroll);
  //   return () => window.removeEventListener('scroll', onScroll);
  // }, [])

  return (
    <>
      <div className="pageContent_m">
        <div className={styles.eventSelectDiv_m}>
          <button style={{backgroundColor:eventColor.all}} id="" className={styles.eventSelectButton_m} onClick={searchEventSelect}>
            전체
          </button>
          <button style={{backgroundColor:eventColor.normal}} id="20001" className={styles.eventSelectButton_m} onClick={searchEventSelect}>
            정상
          </button>
          <button style={{backgroundColor:eventColor.warn}} id="20002" className={styles.eventSelectButton_m} onClick={searchEventSelect}>
            경고
          </button>
          <button style={{backgroundColor:eventColor.danger}} id="20004" className={styles.eventSelectButton_m} onClick={searchEventSelect}>
            위험
          </button>
          <button style={{backgroundColor:eventColor.off}} id="20003" className={styles.eventSelectButton_m} onClick={searchEventSelect}>
            미작동
          </button>
        </div>
        <div className={styles.userSelectDiv_m}>
          <DropDownList
            id="rgn"
            name="rgn"
            data={dataSource.rgnList}
            disabled={!isDeveloper() ? true : false}
            className={styles.rgnDropdown_m}
            value={search.rgns}
            textField="rgnTermSimple"
            dataItemKey="rgnCode"
            defaultItem={defualtValRgn}
            onChange={searchAreaSelect}
          />
          <DropDownList
            id="dong"
            name="dong"
            data={dataSource.dongList}
            disabled={!isAdmin() ? true : !search.rgnCode ? true : false}
            className={styles.dongDropdown_m}
            value={search.dongs}
            textField="dongTermSimple"
            dataItemKey="dongCode"
            defaultItem={defualtValDong}
            onChange={searchAreaSelect}
          />
          <Input
            type="text"
            className={styles.userInput_m}
            placeholder="성함"
            value={userTermValue}
            onChange={searchUserSelect}
          />
        </div>
        <p className={styles.countText}>조회 대상자&nbsp;&nbsp;<b style={{fontSize:"4vw"}}>{dataSource.count}</b> 명</p>
        <ul className={styles.eventDiv_m}>
          <img className={styles.eventImg_m} src="/images/mobile/normal.png"></img>정상&nbsp;
          <img className={styles.eventImg_m} src="/images/mobile/warn.png"></img>경고&nbsp;
          <img className={styles.eventImg_m} src="/images/mobile/danger.png"></img>위험&nbsp;
          <img className={styles.eventImg_m} src="/images/mobile/off.png"></img>미작동&nbsp;
        </ul>
        <div className={styles.userListDiv_m}>
        {dataSource.userDataList.length ? (
          dataSource.userDataList.map(item => {
            return <UserListItemMobile conn={conn} item={item} />;
          })
        ) : (
          <div className={styles.noDataDiv}></div>
        )}
        </div>
      </div>
      {loading && (
        <p
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%,-50%)',
          }}>
          <BeatLoader loading={true} size={18} color="#5e9dd4" />
        </p>
      )}
    </>
  );
}

export default UserListMobile;
